/**
 * L2 idle effects for Saltspray Cove (cove.png).
 *
 * <p>Anchor coordinates are panorama-% of the 2172×724 frame at
 * {@code apps/mobile/src/assets/map_mg/cove.png}.
 *
 * <p>Effects:
 * <ul>
 *   <li>Lighthouse beam — rotating wedge of warm light emanating from
 *       the lantern at the top of the lighthouse on the right edge.
 *   <li>Sea bird drift — a small gull silhouette drifting across the
 *       sky region with a gentle vertical sine.
 * </ul>
 */
export function CoveMidEffects() {
  return (
    <div
      style={{
        position: 'absolute',
        inset: 0,
        pointerEvents: 'none',
        animation: 'gtFadeIn 300ms ease-out',
      }}
    >
      {/* Lighthouse beam — anchored at the lantern (~85% x, ~11% y).
          The wrapper is a square centred on the lantern; inside, a
          triangular cone clipped from a linear gradient rotates 360°
          over 12s. mix-blend-mode: screen gives the "spilling light"
          read against the warm sky. */}
      <div
        style={{
          position: 'absolute',
          top: '11%',
          left: '85%',
          width: '20%',
          height: '60%',
          transform: 'translate(-50%, 0)',
          transformOrigin: '50% 0%',
          animation: 'gtBeam 12s linear infinite',
          mixBlendMode: 'screen',
          opacity: 0.85,
        }}
      >
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background:
              'linear-gradient(180deg, rgba(255,238,170,0.9) 0%, rgba(255,225,140,0.45) 35%, rgba(255,210,120,0.0) 90%)',
            clipPath: 'polygon(50% 0%, 0% 100%, 100% 100%)',
            filter: 'blur(2px)',
          }}
        />
      </div>

      {/* Two gulls drifting across the sky on staggered phases of
          gtBirdDrift — swooping path with banking rotation, not a
          straight line. */}
      <SeaBird delay="0s" startTop="18%" />
      <SeaBird delay="-13s" startTop="24%" />
    </div>
  );
}

interface SeaBirdProps {
  delay: string;
  startTop: string;
}

function SeaBird({ delay, startTop }: SeaBirdProps) {
  return (
    <div
      style={{
        position: 'absolute',
        top: startTop,
        left: 0,
        width: '1.4%',
        height: '2%',
        animation: `gtBirdDrift 28s linear ${delay} infinite`,
        willChange: 'transform',
      }}
    >
      <svg viewBox="0 0 24 12" width="100%" height="100%" preserveAspectRatio="none">
        <path
          d="M 0 8 Q 6 0 12 6 Q 18 0 24 8"
          stroke="rgba(80,60,50,0.7)"
          strokeWidth="1.5"
          fill="none"
        />
      </svg>
    </div>
  );
}
